import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/PageHeader";
import { SelectField } from "@/components/Bits";
import { Field } from "@/components/Field";
import { PagamentosList } from "@/components/PagamentosList";
import { RelatorioComissoes } from "@/components/RelatorioComissoes";
import { ContasTab } from "@/components/ContasTab";
import { ResumoFin } from "@/components/ResumoFin";
import { Totais, Lista, Valores, BonusForm, PagoDialog, listTabs, tabCls } from "@/pages/ComissoesPage";
import { useAuth } from "@/context/AuthContext";
import { useFetch, thisMonth } from "@/lib/useFetch";

export default function FinanceiroPage() {
  const { user } = useAuth();
  const isAdmin = user.role === "admin";
  const [mes, setMes] = useState(thisMonth());
  const [tec, setTec] = useState("");
  const [pago, setPago] = useState(null);
  const [v, setV] = useState(0);
  const { data, reload } = useFetch("/comissoes", { tecnico_id: tec || undefined });
  const { data: equipe } = useFetch("/ordens/equipe");
  const tecSelect = (
    <div className="mb-4 sm:w-72"><SelectField label="Técnico" id="c-tec" placeholder="Todos" value={tec} onChange={(e) => setTec(e.target.value)}
      options={(equipe || []).map((u) => ({ value: u.user_id, label: u.name }))} data-testid="com-tecnico-filter" /></div>
  );
  const mesField = <div className="mb-4 sm:w-56"><Field label="Mês" id="fin-mes" type="month" value={mes} onChange={(e) => setMes(e.target.value)} data-testid="fin-mes" /></div>;
  return (
    <div data-testid="financeiro-page">
      <PageHeader eyebrow="Gestão" title="Financeiro" subtitle="Faturamento, contas a pagar e receber, comissões, pagamentos e relatórios." />
      <Tabs defaultValue="resumo">
        <TabsList className={listTabs}>
          <TabsTrigger value="resumo" className={tabCls} data-testid="tab-resumo">Resumo</TabsTrigger>
          <TabsTrigger value="contas" className={tabCls} data-testid="tab-contas">Contas</TabsTrigger>
          <TabsTrigger value="pagar" className={tabCls} data-testid="tab-pagar">Comissões</TabsTrigger>
          <TabsTrigger value="pagamentos" className={tabCls} data-testid="tab-pagamentos">Pagamentos</TabsTrigger>
          <TabsTrigger value="relatorio" className={tabCls} data-testid="tab-relatorio">Relatório</TabsTrigger>
          {isAdmin && <TabsTrigger value="valores" className={tabCls} data-testid="tab-valores">Valores</TabsTrigger>}
          {isAdmin && <TabsTrigger value="bonus" className={tabCls} data-testid="tab-bonus">Bônus</TabsTrigger>}
        </TabsList>
        <TabsContent value="resumo">{mesField}<ResumoFin mes={mes} version={v} /></TabsContent>
        <TabsContent value="contas">{mesField}<ContasTab mes={mes} onChange={() => setV((x) => x + 1)} /></TabsContent>
        <TabsContent value="pagar">
          {tecSelect}
          {data && <><Totais d={data} /><Lista key={tec} d={data} isAdmin canDelBonus={isAdmin} reload={reload} tec={tec} onPaid={(p) => { setPago(p); setV((x) => x + 1); }} /></>}
        </TabsContent>
        <TabsContent value="pagamentos">{tecSelect}<PagamentosList tecnicoId={tec} version={v} onChange={reload} /></TabsContent>
        <TabsContent value="relatorio"><RelatorioComissoes equipe={equipe} /></TabsContent>
        {isAdmin && <TabsContent value="valores"><Valores /></TabsContent>}
        {isAdmin && <TabsContent value="bonus"><BonusForm equipe={equipe} onSaved={reload} /></TabsContent>}
      </Tabs>
      <PagoDialog pag={pago} onClose={() => setPago(null)} />
    </div>
  );
}
